import { render, staticRenderFns } from "./Calendario.vue?vue&type=template&id=5c57366e&scoped=true"
import script from "./Calendario.vue?vue&type=script&lang=js"
export * from "./Calendario.vue?vue&type=script&lang=js"
import style0 from "./Calendario.vue?vue&type=style&index=0&id=5c57366e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57366e",
  null
  
)

export default component.exports